import type { Category } from './types';

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '全球最受欢迎的运动，涵盖五大联赛、世界杯、欧冠等顶级赛事资讯与战术分析。',
    articleCount: 156,
  },
  {
    id: 'cat-2',
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA等顶级篮球联赛报道，球员动态、比赛回顾与篮球技术指导。',
    articleCount: 128,
  },
  {
    id: 'cat-3',
    slug: 'tennis',
    name: '网球',
    icon: 'ri-base-station-line',
    description: '四大满贯赛事追踪、ATP/WTA排名动态、网球技术教学与器材评测。',
    articleCount: 89,
  },
  {
    id: 'cat-4',
    slug: 'swimming',
    name: '游泳',
    icon: 'ri-drop-line',
    description: '游泳健身指导、泳姿技术分析、游泳赛事资讯与水上运动全面覆盖。',
    articleCount: 67,
  },
  {
    id: 'cat-5',
    slug: 'running',
    name: '跑步',
    icon: 'ri-run-line',
    description: '马拉松训练计划、跑步装备评测、跑步技巧分享与跑步赛事报名指南。',
    articleCount: 112,
  },
  {
    id: 'cat-6',
    slug: 'fitness',
    name: '健身',
    icon: 'ri-mental-health-line',
    description: '科学健身方法、力量训练计划、营养饮食指导与健身达人经验分享。',
    articleCount: 145,
  },
  {
    id: 'cat-7',
    slug: 'yoga',
    name: '瑜伽',
    icon: 'ri-plant-line',
    description: '瑜伽入门到进阶教程、冥想指导、瑜伽哲学与身心平衡健康理念。',
    articleCount: 73,
  },
  {
    id: 'cat-8',
    slug: 'badminton',
    name: '羽毛球',
    icon: 'ri-flight-takeoff-line',
    description: '羽毛球技术教学、赛事报道、装备推荐与业余爱好者交流社区。',
    articleCount: 54,
  },
];